export const DB_COLLECTION = {
  MATH_VAULT: 'math-vault',
  EVENT: 'events',
  STATE: 'state',
  ELEVATORS: 'elevators',
  FLOORS: 'floors',
  CHESTS: 'chests',
  LEVELS: 'levels',
  QUESTIONS: 'questions',
  PLAY_CANVAS: 'play_canvas_summary',
}
